module.exports = __webpack_public_path__ + "shield.svg?71b6a643701ae4ed8237f57009341101";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shield.svg
// module id = 88
// module chunks = 0